/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getStarterPacks.defs.js'
export { main as default } from './getStarterPacks.defs.js'
